import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../service/auth.service";
import {DialogService} from "../../../service/dialog.service";
import {TranslationService} from "../../../service/translation.service";
import {TitleWrapperService} from "../../../service/title-wrapper.service";

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss']
})
export class UserSettingsComponent implements OnInit {

  isLoading = false;


  constructor(
    private authService: AuthService,
    private dialogService: DialogService,
    private translationService: TranslationService,
    private titleService: TitleWrapperService,
  ) {
  }

  ngOnInit(): void {
    this.updateTitle();
  }

  private updateTitle() {
    this.titleService.setPageName(this.translationService.trans("usersettings.page_title", "User settings"));
  }

}
